import { pumatracApi } from '../utils/axios-config'

export default {
    all({language = 'en'} = {}) {
        return pumatracApi.get(`/opportunities/`, {
            headers: {
              common: {
                'Accept-Language': language
              }
            }
        })
    },

    lists({sectionType = '', preview = false} = {}) {
        return pumatracApi.get(`/opportunities/lists/${sectionType}${preview ? '?preview=true' : ''}`)
    },

    get({id, language = 'en'}) {
        return pumatracApi.get(`/generic_opportunities/${id}/`, {
            headers: {
              common: {
                'Accept-Language': language
              }
            }
        })
    },

    global() {
        return pumatracApi.get(`/opportunities/lists/global_opportunities`)
    }
}